<template>
  <div>
    <!--searchMenu-->
    <v-navigation-drawer
      v-model="showSearchMenu"
      right
      absolute      
      class="searchMenuBackground"
      id="searchMenu"
    >

      <v-tabs v-model="tab" mobile-break-point="0">
        <v-tab>
          <v-icon>fas fa-external-link-alt</v-icon>
        </v-tab>


      <v-btn icon class="btnMenuSearch" @click="close()" max-width="40">
      <v-icon id="search-menu-component-items-icon">fas fa-times</v-icon>
    </v-btn>        
      </v-tabs>


      <v-tabs-items v-model="tab" dark>
        <v-tab-item>
          <v-form>
            <v-list dense>
              <search-item :label="$t('SearchItem.ClientCode')" ref="searchClientCode" :itemValue="clientCodeItemValue"
              v-on:itemValueChange="clientCodeItemChanged"></search-item>

              <v-list-item class="listItemSearchMenu">
                <v-list-item-content class="no-top-bottom-padding">
                  <v-flex>
                    <v-menu
                      v-model="menuStartDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="computedStartDateFormatted"
                          append-icon="far fa-calendar-alt"
                          readonly
                          solo
                          v-on="on"
                          height="30"
                          class="searchItemHeight"
                          :placeholder="$t('SearchItem.StartDate')"
                          @click:append="menuStartDate = true"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="startDate"
                        color="#212121"
                        @input="menuStartDate = false"
                        class="datePickerClass"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="listItemSearchMenu">
                <v-list-item-content class="no-top-bottom-padding">
                  <v-flex>
                    <v-menu
                      v-model="menuEndDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="computedEndDateFormatted"
                          append-icon="far fa-calendar-alt"
                          readonly
                          solo
                          v-on="on"
                          height="30"
                          class="searchItemHeight"
                          :placeholder="$t('SearchItem.EndDate')"
                          @click:append="menuEndDate = true"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="endDate" color="#212121" @input="menuEndDate = false"></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-list-item-content>
              </v-list-item>

              <search-item :label="$t('SearchItem.ShipmentNumber')" ref="searchShipmentNumber" :itemValue="shipmentNumberItemValue"
              v-on:itemValueChange="shipmentNumberItemChanged"></search-item>

              <v-list-item class="listItemSearchMenu">
                <v-list-item-content class="no-top-bottom-padding">
                  <v-select
                    v-model="trafficType"
                    :items="trafficTypes"
                    item-value="id"
                    item-text="value"
                    height="30"
                    multiple
                    solo
                    class="searchItemHeight"
                    :label="$t('SearchItem.TrafficType')"
                  ></v-select>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="listItemSearchMenu">
                <v-list-item-content class="no-top-bottom-padding">
                  <span id="lblErrore" class="searchMenuErrorLabel" v-if="showErrore" >Inserisci il codice cliente o/e il numero spedizione</span>
               </v-list-item-content>
              </v-list-item >
              
              <!--BUTTONS-->
              <v-list-item style="padding-top: 10px" class="listItemSearchMenu">
                <v-list-item-content></v-list-item-content>
                <v-list-item-content>
                  <v-btn class="white--text searchMenuButtonLeft" @click="search(true)">
                    <v-icon left>fas fa-search</v-icon>
                    {{ $t("SearchMenu.Button.Search") }}
                  </v-btn>
                </v-list-item-content>
                <v-list-item-content>
                  <v-btn @click="reset()" class="searchMenuButtonRight" color="#FFFFFF">
                    <v-icon left>fas fa-eraser</v-icon>
                    {{ $t("SearchMenu.Button.Reset") }}
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-form>
        </v-tab-item>
      </v-tabs-items>
    </v-navigation-drawer>

    <v-snackbar v-model="showErr" color="error">
      {{ textErr }}
      <v-btn color="white" text @click="showErr=false">{{ $t("Misc.Close") }}</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import loading from "../components/loadingComponent.vue";
import router from "@/router/index.js";
import { Trans } from "@/plugins/Translation";
import searchItem from "../components/searchItemComponent.vue";

export default {
  props: {
    showSearchMenu: Boolean
  },
  mixins: [validationMixin],
  validations: {},
  components: { searchItem },

  data: vm => ({
    startDate: new Date().toISOString().substr(0, 10),
    startDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    endDate: new Date().toISOString().substr(0, 10),
    endDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menuStartDate: false,
    menuEndDate: false,
    StartDate: null,
    EndDate: null,
    showErrore: false,
    load: false,
    showErr: false,
    textErr: "",
    localStorageItemId: "podportal_savedSearchParams",
    localStorageItemGridId: "podportal_savedSearchParamsGrid",
    trafficType: [],
    trafficTypes: [
      { id: "IMPORT", value: "Import" },
      { id: "EXPORT", value: "Export" },
      { id: "NAZIONALE", value: "Nazionale" }
    ],
    tab: null,
    clientCodeItemValue: { value: "", valueType: "StartWith"},
    shipmentNumberItemValue: { value: "", valueType: "StartWith"}
  }),

  watch: {
    menuStartDate: {
      handler(newVal) {
        this.load = true;
      }
    },
    startDate(val) {
      this.startDateFormatted = this.formatDate(this.startDate);
    },
    endDate(val) {
      this.endDateFormatted = this.formatDate(this.endDate);
    }
  },

  computed: {
    computedStartDateFormatted() {
      return this.formatDate(this.startDate);
    },
    computedEndDateFormatted() {
      return this.formatDate(this.endDate);
    },
    currentLanguage() {
      return Trans.i18n;
    }
  },

  mounted() {
    // retrieve params from localStorage if any, otherwise set the default values
    let savedSearchParams = localStorage.getItem(this.localStorageItemId);
    // console.log("get", JSON.parse(localStorage.getItem(this.localStorageItemId)));
    if (
      localStorage.getItem(this.localStorageItemId) == "null" ||
      !localStorage.getItem(this.localStorageItemId)
    ) {
      this.setDefaultValues();
    } else {
      this.setSavedValues(localStorage.getItem(this.localStorageItemId));
    }
  },

  created() {},

  methods: {

    clientCodeItemChanged(value) {      
      this.clientCodeItemValue = value;
    },

    shipmentNumberItemChanged(value) {
      this.shipmentNumberItemValue = value;
    },

    getEndDateToFuture() {
      var startDefaultDate = new Date(
        new Date().getFullYear() + 10,
        new Date().getMonth(),
        new Date().getDate()
      );

      let d =
        startDefaultDate.getFullYear() +
        "-" +
        ("0" + (Number(startDefaultDate.getMonth()) + Number(1))).slice(-2) +
        "-" +
        ("0" + startDefaultDate.getDate()).slice(-2);

      return d;
    },
    setDefaultValues() {
      
      var startDefaultDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        new Date().getDate()
      );

      this.startDate =
        startDefaultDate.getFullYear() +
        "-" +
        ("0" + (Number(startDefaultDate.getMonth()) + Number(1))).slice(-2) +
        "-" +
        ("0" + startDefaultDate.getDate()).slice(-2);

      this.endDate = "";
      
      this.clientCodeItemValue = { value: "", valueType: "Equal"};
      this.shipmentNumberItemValue = { value: "", valueType: "Equal"};      
      this.trafficType = ["", "IMPORT", "EXPORT", "NAZIONALE"];      
    },
    setSavedValues(values) {
      let values_parsed = JSON.parse(values);
      
      this.startDate = values_parsed.startDate;
      this.endDate = values_parsed.endDate;
      
      this.clientCodeItemValue= {value: values_parsed.ClientCodeValue, valueType: values_parsed.ClientCodeType};
      this.shipmentNumberItemValue= {value: values_parsed.ShipmentNumberValue, valueType: values_parsed.ShipmentNumberType};
      this.trafficType = values_parsed.TrafficType;
      
      // console.log("set saved values", values_parsed, "traffictype", values_parsed.trafficType, "set", this.trafficType);        
    },
    search(redirect) {

      if(this.shipmentNumberItemValue.value == "" && this.clientCodeItemValue.value == ""){
        this.showErrore = true; 
        return;
      }
      
      this.showErrore = false; 
      let savedSearchParams = {
        startDate: this.startDate,
        endDate: this.endDate,
        ClientCodeValue: this.clientCodeItemValue.value,
        ClientCodeType: this.clientCodeItemValue.valueType,
        ShipmentNumberValue: this.shipmentNumberItemValue.value,
        ShipmentNumberType: this.shipmentNumberItemValue.valueType,
        TrafficType: this.trafficType
      };
      //console.log("search", savedSearchParams);
            
      if (new Date(this.startDate) > new Date(this.endDate)) {
        // this.showSearchError = true;
        this.showErr = true;
        this.textErr = Trans.i18n.t("Validations.WrongSearchDates");
        return;
      }

      localStorage.setItem(
        this.localStorageItemId,
        JSON.stringify(savedSearchParams)
      );

      this.saveGridFilters(savedSearchParams);

      var lolSFilter = JSON.parse(localStorage.getItem("FullTextWithLike"));
      if(lolSFilter)
        localStorage.removeItem("FullTextWithLike")

      if (redirect) {
        router.push({ name: "Index" }).catch(err => {
          //sono già nella pagina
          //console.log("refresh page");
          this.$store.commit(
            "SET_reloadPage",
            !this.$store.getters.GET_reloadPage
          );
        });
      }
    },
    saveGridFilters(savedSearchParams) {
      if (!savedSearchParams.endDate) {
        savedSearchParams.endDate = this.getEndDateToFuture();        
      }
      
      // added 1 day to end filter
      savedSearchParams.endDate = this.setEndDateFilter(savedSearchParams.endDate);
     
      let objectToPassAtGrid = [
        {
          Field: "ShipmentDate",
          Filtervalue: [savedSearchParams.startDate, savedSearchParams.endDate],
          Filtertype: "Between"
        },
        { Field: "FileName", Filtervalue: "`_", Filtertype: "NotContains" }
      ];

      if (savedSearchParams.ClientCodeValue)
        objectToPassAtGrid.push({
          Field: "ClientCode,SenderCode,RecipientCode",
          Filtervalue: savedSearchParams.ClientCodeValue,
          Filtertype: savedSearchParams.ClientCodeType
        });

      if (savedSearchParams.ShipmentNumberValue)
        objectToPassAtGrid.push({
          Field: "ShipmentCode",
          Filtervalue: savedSearchParams.ShipmentNumberValue,
          Filtertype: savedSearchParams.ShipmentNumberType
        });

      if (savedSearchParams.TrafficType.length > 0)
        objectToPassAtGrid.push({
          Field: "TrafficType",
          Filtervalue: savedSearchParams.TrafficType,
          Filtertype: "Or"
        });

      // always filter null traffic type
      if (!savedSearchParams.TrafficType.includes("")) {
        savedSearchParams.TrafficType.push("");
      }
      
      //console.log("savedSearchParams", savedSearchParams);
      // console.log("saved to grid", objectToPassAtGrid);
      localStorage.setItem(
        this.localStorageItemGridId,
        JSON.stringify(objectToPassAtGrid)
      );
      this.$store.commit("SET_elementToSearchOfGridMenu", objectToPassAtGrid);
    },
    reset() {
      this.setDefaultValues();
      this.search(false);      
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    close() {
      let showSM = {
        show: false,
        style: "color: #cecece"
      };
      
      this.$store.commit("SET_showSearchMenu", showSM);
    },
    setEndDateFilter(endDate) {
      var newEndDate = new Date(endDate);      
      var newEndDateForFilter =  newEndDate.setDate(newEndDate.getDate() + 1);
      return new Date(newEndDateForFilter).getFullYear() + "-" + (new Date(newEndDateForFilter).getMonth() + 1)  + "-" + new Date(newEndDateForFilter).getDate();
    }
  }
};
</script>